import type { IPresentationDataModel } from '../model/presentation-data-model';
import type { ISectionDataModel } from '../model/section-data-model';
import type { IThemeDataModel } from '../model/theme-data-model';
import type { IPageDataModel } from '../model/page-data-model';
import type { ITimingDataModel } from '../model/timing-data-model';
import type { IBaseShapeDataModel } from '../model/base-shape-data-model';

export type TargetDataModel =
    | IPresentationDataModel
    | IPageDataModel
    | ITimingDataModel
    | IThemeDataModel
    | ISectionDataModel
    | IBaseShapeDataModel;

export interface IBaseContext {
    getPresentation(): IPresentationDataModel;
    getTarget(): TargetDataModel | undefined;
}

export class BaseContext implements IBaseContext {
    protected presentation?: IPresentationDataModel;
    protected target?: TargetDataModel;

    public getPresentation(): IPresentationDataModel {
        if (!this.presentation) {
            throw new Error('getPresentation from BaseContext without setPresentation');
        }

        return this.presentation;
    }

    public setPresentation(presentation: IPresentationDataModel): void {
        this.presentation = presentation;
    }

    public setTarget(target: TargetDataModel) {
        this.target = target;
    }

    public getTarget() {
        return this.target;
    }
}
